import { DEPRECATED_Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";

type Props = {
  messages: string[];
};

export const PreOrderMessageUI = ({ messages }: Props) => {
  if (!messages.length) {
    return null;
  }

  return (
    <DEPRECATED_Message
      type="information"
      body={
        <>
          {messages.map((message, index) => (
            <div key={index}>{message}</div>
          ))}
        </>
      }
      containerProps={{ ["data-component"]: "PreOrderMessage" }}
    />
  );
};
